import { useTranslation } from "react-i18next";
import { Pressable } from "react-native";
import { Caption, Text } from "react-native-paper";

import { useAppTheme } from "@hooks/useAppTheme";

import type { OriginalStimulusTypes } from "@memorang/types/src/session/new-session";
import { Box, Button, useDevice } from "@memorang/ui";
import AudioPlayerContainer from "../containers/AudioPlayerContainer";
import { getStimulusData } from "../helpers";

export const PassageStem = ({
	parentStem,
	parentAudio,
	toggleShowReadMore,
	index,
	numPassageItems,
	parentTitle,
	parentType,
	itemId,
	video,
}: {
	parentStem?: string;
	numPassageItems?: number;
	inReviewMode?: boolean;
	toggleShowReadMore?: () => void;
	index?: number;
	parentAudio?: string;
	parentTitle?: string;
	parentType: OriginalStimulusTypes;
	itemId: number;
	video?: string;
}) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	const { isMobile } = useDevice();

	const { text: cta, icon } = getStimulusData(parentType, t);

	return (
		<Box>
			<Box
				backgroundColor={theme.colors.surface}
				borderBottomWidth={1}
				borderBottomColor={theme.colors.divider}
			>
				{parentAudio && (
					<Box
						paddingHorizontal={isMobile ? 16 : 0}
						paddingBottom={isMobile ? 8 : 0}
					>
						<AudioPlayerContainer uri={parentAudio} itemId={itemId} />
					</Box>
				)}
				{/* {video && <VideoPlayer videoUrl={video} />} */}
				{parentStem || parentTitle ? (
					<Pressable onPress={toggleShowReadMore}>
						<Box
							flexDirection="row"
							justifyContent="space-between"
							alignItems="center"
							paddingBottom={16}
						>
							<Box paddingHorizontal={16} flex={1}>
								<Text variant="titleMedium" numberOfLines={1}>
									{parentTitle}
								</Text>
								<Caption>
									{t("session.passageStem.item")} {index}{" "}
									{t("session.passageStem.of")} {numPassageItems}
								</Caption>
							</Box>
							<Button icon={icon} mode="text" onPress={toggleShowReadMore}>
								{cta}
							</Button>
						</Box>
					</Pressable>
				) : null}
			</Box>
		</Box>
	);
};
